import { colors, sizes } from "assets/constants";
import { StyleSheet } from "react-native";
import { sn } from "utils";

const css = {
  ...StyleSheet.create({
    cover: { flex: 1 },

    container: { flex: 1 },
    containerMaxWidth: { maxWidth: sizes.containerMaxWith },
    growContainer: { flexGrow: 1 },

    fitWidth: { width: "100%" },
    fitHeight: { height: "100%" },

    centralElements: { alignItems: "center", justifyContent: "center" },
    centralElContainer: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },

    row: { flexDirection: "row" },
    rowCenterAlign: { flexDirection: "row", alignItems: "center" },
    rowStartAlign: { flexDirection: "row", alignItems: "flex-start" },
    rowEndAlign: { flexDirection: "row", alignItems: "flex-end" },

    rRow: { flexDirection: "row-reverse" },
    rRowCenterAlign: { flexDirection: "row-reverse", alignItems: "center" },
    rRowContainerCenterAlign: {
      flexDirection: "row-reverse",
      alignItems: "center",
      flex: 1,
    },
    rRowStartAlign: { flexDirection: "row-reverse", alignItems: "flex-start" },
    rRowEndAlign: { flexDirection: "row-reverse", alignItems: "flex-end" },

    rowCenterAlignSpaceBetween: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    rowCenterAlignSpaceEvenly: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-evenly",
    },
    rowCenterAlignSpaceAround: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-around",
    },
    rowCentral: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },

    rRowCenterAlignSpaceBetween: {
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-between",
    },
    rRowCenterAlignSpaceEvenly: {
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-evenly",
    },
    rRowCenterAlignSpaceAround: {
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-around",
    },
    rRowCentral: {
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "center",
    },

    wrap: { flexWrap: "wrap" },

    alignCenter: { alignItems: "center" },
    alignStart: { alignItems: "flex-start" },
    alignEnd: { alignItems: "flex-end" },

    selfCenter: { alignSelf: "center" },
    selfStart: { alignSelf: "flex-start" },
    selfEnd: { alignSelf: "flex-end" },

    justifySpaceEvenly: { justifyContent: "space-evenly" },
    justifySpaceAround: { justifyContent: "space-around" },
    justifySpaceBetween: { justifyContent: "space-between" },
    justifyEnd: { justifyContent: "flex-end" },
    justifyStart: { justifyContent: "flex-start" },
    justifyCenter: { justifyContent: "center" },

    overFlowH: { overflow: "hidden" },

    textUnderline: { textDecorationLine: "underline" },

    colCenterAlignX: { alignItems: "center" },
    colCenterAlignY: { justifyContent: "center" },

    absolute: { position: "absolute" },

    absoluteFitContent: { position: "absolute", width: "100%", height: "100%" },

    containerW: { width: "93%" },
    paddingH: { paddingHorizontal: sizes.space },
    marginH: { marginHorizontal: sizes.space },

    screenBg: { backgroundColor: colors.screensBg },

    removeGaps: {
      padding: 0,
      paddingRight: 0,
      paddingLeft: 0,
      paddingTop: 0,
      paddingBottom: 0,
      paddingVertical: 0,
      paddingHorizontal: 0,
      margin: 0,
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      marginVertical: 0,
      marginHorizontal: 0,
    },

    responsiveListContainer: sn(false, false, true, true)
      ? {
          justifyContent: "space-between",
          flexDirection: "row-reverse",
          alignItems: "center",
          flexWrap: "wrap",
        }
      : {},

    // responsiveBoxContainer: {
    //   width: sn(
    //     "100%",
    //     "100%",
    //     (sizes.screenW - 2 * sizes.space) / 2 - 6,
    //     (sizes.screenW - 2 * sizes.space - sizes.drawerW) / 2 - 7
    //   ),
    //   alignSelf: "center",
    //   marginBottom: sizes.space,
    // },
    responsiveBoxContainer: {
      width: sn("100%", "100%", "49%", "49%"),
      alignSelf: "center",
      marginBottom: sizes.space,
    },

    responsiveInputContainer: { width: sn("100%", "100%", "49%", "49%") },

    responsiveInputsListContainer: {
      padding: sizes.space,
      flexWrap: "wrap",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      maxWidth: sizes.deviceWidth.xl,
      width: "100%",
      alignSelf: "center",
    },

    inputContainer: {
      width: "100%",
      height: sn(43, 48, 48, 48),
      borderWidth: 1,
      flexDirection: "row",
      alignItems: "center",
      borderColor: colors.border,
      borderRadius: sizes.radius.lg,
      backgroundColor: colors.itemsBg,
      overflow: "hidden",
    },

    inputIconContainer: {
      height: "100%",
      width: sizes.isMediumScreen ? 40 : 45,
      alignItems: "center",
      justifyContent: "center",
    },
  }),

  // --------------
  shadow: (val: number) => {
    return {
      shadowColor: "#000000",
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowOpacity: (val - 1) * 0.02 + 0.18,
      shadowRadius: val === 1 ? 1 : val * 0.7,
      elevation: val,
    };
  },

  // -----------
  dropShadow: (
    x = 0,
    y = 0,
    shadowOpacity = 0.5,
    shadowRadius = 5,
    shadowColor = "#dddddd"
  ) => ({
    shadowOffset: { width: x, height: y },
    shadowOpacity,
    shadowRadius,
    shadowColor,
  }),
};

export default css;
